<template lang="pug">
div
	v-e24-nav-bar
	section.maincolumn-constrained
		.form-in-columns
			.side
				new-customer-form(:snackbar="snackbar")
			.side
				login-form(:goodbye="goodbye", :redirect="redirect")
	v-e24-footer(:build="build")

	md-snackbar(md-position='center', :md-duration='snackbar.duration', :md-active.sync='snackbar.show', md-persistent='')
		span {{ $t(snackbar.message) }}
		md-button.md-primary(@click='snackbar.show = false') {{ $t('label.ok') }}
</template>

<script>
import loginForm from 'CommonApp/security/login-form.vue'
import newCustomerForm from './new-customer.vue'
import readBuild from '../../util/readBuild'

export default {
	name: 'Login',
	props: ['goodbye', 'redirect'],
	data () {
		return {
			build: '',
			snackbar: { show: false, message: '', duration: 3000 }
		}
	},
	components: { loginForm, newCustomerForm },
	methods: {},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	}
}
</script>



// WEBPACK FOOTER //
// src/app/login/login-component.vue